@let layoutValue = layout();
<div
    class="wrapper"
    [class.sidebar-expanded]="isSidebarExpanded()"
    [class.no-header]="!layoutValue?.header"
    [class.no-sidebar]="!layoutValue?.sidebar"
    [class.on-listings-details-page]="isListingDetailsPage()"
    [class.on-outlets-page]="isOutletDetailsPage()"
    [class.on-rooms-page]="isRoomsDetailsPage()"
    [class.on-bulk-page]="isBulkEditPage()"
>
    <div class="corner">
        <!-- The if is needed instead of dynamic height due to the use of NgOptimizedImage, which does not support dynamic height -->
        @if (isSidebarExpanded()) {
            <img [ngSrc]="IMAGES.LOGOS.SHIJI_LOGO_BLUE0_SVG" height="60" width="322" alt="Shiji Logo" priority />
        } @else {
            <img [ngSrc]="IMAGES.LOGOS.SHIJI_LOGO_BLUE0_SVG" height="40" width="322" alt="Shiji Logo" priority />
        }
    </div>

    <header>
        <app-header [isVisible]="!!layoutValue?.header" />
    </header>

    <aside class="sidebar">
        <app-sidebar />
    </aside>

    @let sidebarTypeValue = sidebarType();
    @if (sidebarTypeValue) {
        <div class="context-sidebar">
            <app-context-aware-sidebar [sidebarType]="sidebarTypeValue"></app-context-aware-sidebar>
        </div>
    }

    <main (scroll)="handleScroll($event)">
        @if (sidebarTypeValue && featureFlagService.featureFlags()[FeatureFlagEnum.UNIFIED_LISTING]) {
            <app-listing-comparison-banner />
        }
        <router-outlet />
    </main>
</div>
<app-modal />
<app-toast />
<app-loader class="mainLoader" [type]="'overlaidSpinner'" [matchExcept]="loaderExcludedUrls" />
<ng-container #tooltipHost></ng-container>
<ng-container #modalHost></ng-container>
